import React from 'react'
import { HeaderGroup } from 'react-table'
import { IColumn } from 'src/components/BaseTable'
import { SelectFilterGeneric } from 'src/components/ColumnsFiltersTable'
import { EditarStatusRecord } from 'src/components/EditarStatusRecord'
import When from 'src/components/When'
import { DeleteRecord } from '../../components'
import { statusCentroCusto } from './types'

interface ICentroCustosColumnProps {
  onDelete: (id: string) => void
  authorization?: {
    canCreate?: boolean
    canDelete?: boolean
    canUpdate?: boolean
  }
}

export const CentrosCustoColumns = ({
  onDelete,
  authorization
}: ICentroCustosColumnProps): IColumn[] => {
  return [
    {
      Header: 'Código',
      accessor: 'codigo'
    },
    {
      Header: 'Código Rodopar',
      accessor: 'codigoRodopar'
    },
    {
      Header: 'Descrição',
      accessor: 'descricao'
    },
    {
      Header: 'Unidade de Negócio',
      accessor: 'unidadeNegocio'
    },
    {
      Header: 'Status',
      accessor: 'status',
      Filter: props =>
        SelectFilterGeneric({
          column: props.column as HeaderGroup<{}>,
          options: statusCentroCusto
        })
    },
    {
      Header: 'CNPJ',
      accessor: 'cnpj',
      show: false
    },
    {
      Header: 'Inscrição Estadual',
      accessor: 'inscricaoEstadual',
      show: false
    },
    {
      Header: 'Telefone',
      accessor: 'telefone',
      show: false
    },
    {
      Header: '',
      accessor: 'actions',
      sort: false,
      selectable: false,
      defaultClick: false,
      Cell: (props: any) => (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          {props.row.original && (
            <>
              <When value={authorization?.canUpdate} equals>
                <DeleteRecord
                  onDelete={() => onDelete(props.row.original.id)}
                />
              </When>

              <When value={authorization?.canUpdate} equals>
                <EditarStatusRecord
                  status={'ATIVO'}
                  isCentroCusto
                  id={props.row.original.id}
                  isStatusChangeable={true}
                  optionsStatus={['ATIVO', 'INATIVO'].filter(
                    status => status !== props.row.original.status
                  )}
                />
              </When>
            </>
          )}
        </div>
      )
    }
  ]
}
